import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('@layouts/blank/blank.component').then((m) => m.BlankComponent),
		children: [
			{
				path: '',
				redirectTo: '/authentication/login',
				pathMatch: 'full',
			},
			{
				path: 'authentication',
				loadChildren: () =>
					import('@features/authentication/authentication.routes').then(
						(m) => m.AuthenticationRoutes
					),
			},
		],
	},
	{
		path: '',
		loadComponent: () => import('@layouts/full/full.component').then((m) => m.FullComponent),
		loadChildren: () =>
			import('@features/features.routes').then((m) => m.FeaturesRoutes),
	},
	{
		path: '**',
		redirectTo: 'authentication/error',
	},
];
